import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  background-color: var(--white);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  // Contrataste con exito Container
  .contratasteContainer {
    width: 100%;
    max-width: 1270px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 35px 0px 0px 0px;
  }

  // Title
  .contratasteContainer h2 {
    width: 100%;
    text-align: left;
    color: var(--green);
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2em;
  }

  .contratasteContainer h2 span {
    margin-right: 10px;
    font-size: 0.8em !important;
  }

  // Data Container
  .dataContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .dataContainer img {
    display: block;
    height: auto;
    object-fit: contain;
  }

  // Data Text
  .dataText {
    width: auto;
    max-width: 860px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: flex-start;

    #textoNombre,
    #textoDatos {
      width: 100%;
      color: var(--black);
      font-family: Raleway;
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      text-align: left;
      margin: 0px 0px 0px 0px;
    }

    #textoDatos {
      font-weight: normal;
      margin: 6px 0px 0px 0px;
    }
  }

  //  Data seguro
  .dataSeguro {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    margin: 10px 0px 40px 0px;
  }

  .dataSeguro img {
    max-width: 150px;
    height: auto;
    object-fit: contain;
  }

  .dataSeguro div {
    margin-left: 30px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .dataSeguro div p {
    width: 100%;
    text-align: left;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    margin: 3px 0px 3px 0px;
    color: var(--black);
  }

  .dataSeguro div p:nth-child(2) {
    color: var(--orange) !important;
    font-size: 13px !important;
  }

  // Datos preparados
  .datosPreparados {
    width: 50%;
    max-width: 440px;
    display: flex;
    justify-content: space-between;
    align-content: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 45px 0px 0px 0px;

    div {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;
      margin: 3px 0px 0px 0px;
    }

    span {
      color: var(--green);
      margin: 4px 0px 0px 0px;
    }

    p {
      margin: 0px 0px 0px 10px !important;
      font-family: Raleway !important;
      font-style: normal !important;
      font-weight: normal !important;
      font-size: 15px !important;
      line-height: 28px !important;
    }
  }

  // Data contacto
  .dataContacto {
    width: 100%;
    margin: 55px 0px 0px 0px;

    p {
      width: 100%;
      text-align: left;
      font-family: Raleway;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      margin: 0px 0px 0px 0px;
      line-height: 24px;
      color: var(--black);
    }
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Data Text
    #textoNombre,
    #textoDatos {
      font-size: 0.96em !important;
    }

    // Datos preparados
    .datosPreparados {
      p {
        font-size: 0.96em !important;
      }
    }

    // Data contacto
    .dataContacto {
      p {
        font-size: 0.96em;
      }
    }
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 1100px;
    }

    // Data Text
    .dataText {
      max-width: 700px;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Data Text
    #textoNombre,
    #textoDatos {
      font-size: 0.938em !important;
    }

    // Datos preparados
    .datosPreparados {
      p {
        font-size: 0.938em !important;
      }
    }

    // Data contacto
    .dataContacto {
      p {
        font-size: 0.938em;
      }
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 1000px;
    }

    // Data Text
    .dataText {
      max-width: 650px;
    }

    #textoNombre,
    #textoDatos {
      width: 80% !important;
      line-height: 25px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 850px;
    }

    // Data Text
    .dataText {
      max-width: 500px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 700px;
    }

    #textoNombre,
    #textoDatos {
      width: 100% !important;
    }

    #textoDatos {
      margin: 0px 0px 45px 0px !important;
    }

    // Datos preparados
    .datosPreparados {
      width: 100%;
      max-width: 300px;
      margin: 0px 0px 0px 0px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Data Container
    .dataContainer {
      flex-wrap: wrap;
      flex-direction: row;
    }

    .dataContainer img:nth-child(2) {
      margin: 45px 0px 0px 0px;
    }

    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 600px;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 540px;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 480px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 400px;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    // Contrataste con exito Container
    .contratasteContainer {
      max-width: 88%;
    }

    // Data Container
    .dataContainer img:nth-child(2) {
      max-width: 88% !important;
      margin: 0 auto;
      padding: 45px 0px 0px 0px;
    }
  }

  // 280px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile280}) {
    //  Data seguro
    .dataSeguro {
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      text-align: center !important;
    }

    .dataSeguro div {
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 20px 0px 0px 0px;
    }

    .dataSeguro div p {
      text-align: center !important;
    }

    #textoNombre,
    #textoDatos {
      width: 100% !important;
    }
  }
`;

export default Container;
